export default __webpack_public_path__ + "static/0046-1fe86e677f4df63ed1d066924648df9e.pdf";